import React, { useState } from "react";
import useClickOutSide from "../../../utils/custom-hooks/useClickOutside";
import ZFIcon from "../ZFIcon/ZFIcon";

const ZFItemSelector: React.FC<IItemSelectorProps> = ({
	items,
	activeItem,
	onActiveItemChange,
}) => {
	// const [currentActiveItem, updateCurrentActiveItem] = useState(activeItem);
	const [showItemSelector, updateShowItemSelector] = useState(false);

	// useEffect(() => {
	//     updateCurrentActiveItem(activeItem);
	// }, [activeItem]);

	const toggleListVisibility = () => {
		updateShowItemSelector(!showItemSelector);
	};

	const selectItem = (item: number) => {
		// updateCurrentActiveItem(items.itemList[index]);
		updateShowItemSelector(false);
		onActiveItemChange(item);
	};

	const resetVisibility = () => {
		updateShowItemSelector(false);
	};

	const clickOutsideRef = useClickOutSide(resetVisibility);

	return (
		<div className="zf-item-selector" ref={clickOutsideRef}>
			<button
				onClick={() => toggleListVisibility()}
				className={
					"selector-pick-btn " +
					(showItemSelector ? "list-visible" : "")
				}
			>
				<span>{activeItem}</span>
				<ZFIcon
					iconName="collapse"
					iconClasses={["zf-icon-react--size-xs", "ioc-collapse"]}
				/>
			</button>
			{showItemSelector && (
				<div className="selector-dropdown" style={{ display: "block" }}>
					<div className="list-header">{items.header}</div>
					{items.itemList.map((item, i) => {
						return (
							<div key={`item_selector_${items.header}_${item}`}
								onClick={() => selectItem(item)}
								className="selector-dd-item"
								style={{
									marginBottom:
										i === items.itemList.length - 1
											? "8px"
											: "0px",
								}}
							>
								<div
									className={
										"left-align-dropdwn " +
										(item === activeItem
											? "active-item"
											: "")
									}
								>
									{item}
								</div>
							</div>
						);
					})}
				</div>
			)}
		</div>
	);
};

export default ZFItemSelector;

export interface IItemSelector {
	header: string;
	itemList: Array<number>;
}

export interface IItemSelectorProps {
	items: IItemSelector;
	activeItem: number;
	onActiveItemChange: (item: number) => void;
}
